import type { GlobalSetupRecord, HomeAlertsRecord } from "@/utils/PocketBaseAdapter";
import { pb } from "@/utils/PocketBaseAdapter";
import { defineStore } from "pinia";

export const useGlobalSetupStore = defineStore("GlobalSetup", {
  state: () => ({
    globalSetup: <GlobalSetupRecord>{},
    homeAlerts: ref<HomeAlertsRecord[]>([]),
    maxSizeInMB: 2,
  }),

  getters: {
    maxSizeInBytes: (state) => state.maxSizeInMB * 1024 * 1024,
  },

  actions: {
    // 👉 get globalSetup data
    async getGlobalSetup() {
      this.globalSetup = await pb.collection("globalSetup").getOne<GlobalSetupRecord>("hjrxf532dcxwsdp");
    },
    async getHomeAlerts(location: string) {
      try {
        const records = await pb.collection("homeAlerts").getFullList<HomeAlertsRecord>({
          filter: `location= "${location}"`,
        });

        if (records) {
          this.homeAlerts = records;
        }
      } catch (e) {}
    },
  },
});
